import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledParagraphWithDemoComponent } from "./paragraph-with-demo-component.scss";
const ParagraphWithDemoComponent = ({ title, description, translate, icon: Icon, demoComponent: DemoComponent, demoComponentMetadata, templateData, templateDataFieldName })=>{
    const shouldHideComponent = ()=>{
        return templateDataFieldName && !templateData[templateDataFieldName];
    };
    return shouldHideComponent() ? null : /*#__PURE__*/ _jsxs(StyledParagraphWithDemoComponent, {
        className: "paragraph-with-demo",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "paragraph-content-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "paragraph-content-title",
                        children: title
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "paragraph-content-description-wrapper",
                        children: [
                            Icon && /*#__PURE__*/ _jsx("div", {
                                className: "paragraph-content-icon",
                                children: /*#__PURE__*/ _jsx(Icon, {})
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "paragraph-content-description",
                                children: description
                            })
                        ]
                    })
                ]
            }),
            DemoComponent && /*#__PURE__*/ _jsx("div", {
                className: "paragraph-demo-wrapper",
                children: /*#__PURE__*/ _jsx(DemoComponent, {
                    translate: translate,
                    metadata: demoComponentMetadata,
                    templateData: templateData
                })
            })
        ]
    });
};
export default withGenericConfig(ParagraphWithDemoComponent);
